<template>
    <div class="q-px-md q-pb-md container-in-search-suggestions">
        <div class="text-uppercase">
            <b class="black-text search-text">{{ searchInputValue }}</b> {{ $t("shared.Search in") }}
        </div>
        <!-- Buttons for searching in different contexts -->
        <div class="search-in-btns-container">
            <SearchInContext @on-context-selection="onContextSearchHandler" :items="searchTabs ?? []" />
            <template v-if="hasAccess">
                <ShowIfHasAccess :feature-id="AccessFeature.rag_search_dropdown_gui">
                    <QitButton
                        color="secondary"
                        :label="$t('ai-assistant.AI Assistant')"
                        icon="fak fa-regular fa-qit-ai-assistant-regular"
                        @click="() => onContextSearchHandler(CommonRouteAliases.aiAssistant)"
                        data-qs="search-in-ai-assistant-btn"
                    />
                </ShowIfHasAccess>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
import SearchInContext from "@/shell/pages/header/search/search-in-context.vue";
import { SearchTab } from "@/shared/environment/ability.types";
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases.ts";
import { AccessFeature } from "@/shared/access-control/access-control.ts";
import ShowIfHasAccess from "@/shared/access-control/components/show-if-has-access.vue";
import { useAiAssistantAccess } from "@/shared/ai-assistant/ai-assistant-access.ts";

defineProps<{
    searchInputValue: string;
    searchTabs: SearchTab[];
}>();

const emit = defineEmits(["onContextSelection"]);

const { hasAccess } = useAiAssistantAccess();

const onContextSearchHandler = (searchInCategory: string) => {
    emit("onContextSelection", searchInCategory);
};
</script>

<style lang="scss" scoped>
.search-text {
    word-break: break-word;
}
.search-in-btns-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: #{$spacing-m + $spacing-s};
    margin-top: $spacing-l;
    :deep(i) {
        font-size: 16px;
    }
}
</style>
